/*
 * Signal „Server sagt gesperrt" -- eigene Datei, damit die API-Aufrufe es
 * melden koennen, ohne die Passwortseite (und mit ihr die halbe Oberflaeche)
 * zu importieren. Gehoert zu lib/gate.tsx.
 */

export const LOCKED_EVENT = 'rabbitfuel:gate-locked';

/**
 * Von den API-Aufrufen gerufen, wenn der Server mit „gesperrt" antwortet --
 * etwa weil das Passwort am Server geaendert wurde, waehrend die Seite offen
 * war. Dann kommt die Passwortseite zurueck.
 */
export function reportGateLocked(status: number, body: unknown) {
  if (status === 401 && (body as { code?: string } | null)?.code === 'gate_locked') {
    window.dispatchEvent(new Event(LOCKED_EVENT));
  }
}
